import * as React from 'react'
import {useEffectOnceWhen } from "rooks"
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import SpeedIcon from '@mui/icons-material/Speed'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Drawer from '@mui/material/Drawer'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import ZoomInIcon from '@mui/icons-material/ZoomIn'

import {ReactComponent as MaskLogo} from './svg/mask.svg'
import Switch from '@mui/material/Switch'
import MenuIcon from '@mui/icons-material/Menu'
import AnimationIcon from '@mui/icons-material/Animation';
//MANGA SUPPORT IMPORTS
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
//import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import { isMobile } from './utils/deviceUtils';

import {CustSlider, Copyright} from './ExcelsiorElementsLibrary'


    import { useSelector, useDispatch } from 'react-redux';
    import { 
      setZoomMax,
      setSettingsMenuOpen,
      setTransitionSpeed,
      setFabMenuSwitchValue,
      setFocusAnimationSwitchValue
     } from './store/readerSlice';


export default function ExcelsiorSettingsDrawer(props) {
  

      //REDUX
      const dispatch = useDispatch()
      const ZOOM_MAX = useSelector(state => state.reader.zoomMax)
      const TRANSITION_SPEED = useSelector(state => state.reader.transitionSpeed)
      // const MANGA_SWITCH_VALUE = useSelector(state => state.reader.mangaSwitchValue)
      const MENU_SWITCH_VALUE = useSelector(state => state.reader.fabMenuSwitchValue)
      const FOCUS_ANIM_SWITCH_VALUE = useSelector(state => state.reader.focusAnimationSwitchValue)
      const working = useSelector(state => state.reader.working)
      const settingsMenuOpen = useSelector(state => state.reader.settingsMenuOpen)

      const getDefaultMaxZoom = useSelector(state => state.reader.defaultZoomMax)
     const getDefaultTransitionSpeed = useSelector(state => state.reader.defaultTransitionSpeed)
     const getDefaultFabMenuSwitch = useSelector(state => state.reader.defaultFabMenuSwitchValue)
     const getDefaultFocusAnimationSwitch = useSelector(state => state.reader.defaultFocusAnimationSwitchValue)


      const setSettingsMenuOpenStore = (v) => dispatch(setSettingsMenuOpen(v))
      const setZoomMaxStore = (v) => dispatch(setZoomMax(v))
      const setTransitionSpeedStore = (v) => dispatch(setTransitionSpeed(v))
      // const setMangaSwitchValueStore = (v) => dispatch(setMangaSwitchValue(v))
     const setFabMenuSwitchValueStore = (v) => dispatch(setFabMenuSwitchValue(v))
     const setFocusAnimationSwitchValueStore = (v) => dispatch(setFocusAnimationSwitchValue(v))
  
    const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  // const [activeStep, setActiveStep] = useSessionstorageState("excelsior:tipactivestep", 0)
  //const [activeStep, setActiveStep] = React.useState(0)
  const theme = useTheme()

  // const handleNext = () => {
  //   var i = activeStep + 1
  //   setActiveStep(activeStep => i)
  // };

  // const handleBack = () => {
  //   var i = activeStep - 1
  //   setActiveStep(activeStep => i)
  // };

  useEffectOnceWhen(() => {
    toggleDrawer(props.anchor, true)
  }, [])


    const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open })
    setSettingsMenuOpenStore(open)
  }

  const handleZoomMaxSliderChange = (event, newValue) => {
    if(working) {return}
    if (typeof newValue === 'number') {
      setZoomMaxStore(newValue)
    }
  }

  const handleTransSpeedSliderChange = (event, newValue) => {
    if(working) {return}
    if (typeof newValue === 'number') {
      setTransitionSpeedStore(newValue)
    }
  }

  // const handleMangaSwitch = (event, newValue) => {
  //   if(working) {return}
  //   if (typeof newValue === 'boolean') {
  //       setMangaSwitchValueStore(newValue)
  //      }
  // }
  const handleFabMenuSwitch = (event, newValue) => {
    if(working) {return}
    if (typeof newValue === 'boolean') {
        setFabMenuSwitchValueStore(newValue)
       }
  }
  const handleFocusAnimSwitch = (event, newValue) => {
    if(working) {return}
    if (typeof newValue === 'boolean') {
        setFocusAnimationSwitchValueStore(newValue)
       }
  }
 
  function valueLabelFormat(value) {
    return `${value}x`
  }
  function valueLabelFormatSeconds(value) {
    let sec = value === 1 ? "second" : "seconds"
    return `${value} ${sec}`
  }

  const resetDefaultsHandler = (event) => {
    setZoomMaxStore(getDefaultMaxZoom)
    setTransitionSpeedStore(getDefaultTransitionSpeed)
    setFabMenuSwitchValueStore(getDefaultFabMenuSwitch)
    setFocusAnimationSwitchValueStore(getDefaultFocusAnimationSwitch)
  }

  // const DotStepperBar =() =>{
  //   return(
  //     <DotStepper
  //     variant="dots"
  //     steps={maxSteps}
  //     position="static"
  //     activeStep={activeStep}
  //     sx={{ maxWidth: "100%", flexGrow: 1 }}
  //     nextButton={
  //       <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
  //         {theme.direction === 'rtl' ? (
  //           <KeyboardArrowLeft />
  //         ) : (
  //           <KeyboardArrowRight />
  //         )}
  //       </Button>
  //     }
  //     backButton={
  //       <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
  //         {theme.direction === 'rtl' ? (
  //           <KeyboardArrowRight />
  //         ) : (
  //           <KeyboardArrowLeft />
  //         )}
  //       </Button>
  //     }
  //   />
  //   )
  // }

//   const TipCard1=()=>{
//     return(
//       <div>
//        <Box 
//        sx={{
//         display:"block",
//         width:"inherit",
//         textAlign:"center",
//         alignContent:"center"
//         }}
//        >
//        <Stack alignItems="center">
//       <Card 
//       sx={{ 
//         minWidth: 100,
//         minHeight: 180,
//         maxHeight: 180,
//         backgroundColor: "rgba(0, 0, 0, .45)"
//         }}>
//       <CardContent>
//         <Typography variant="subtitle2" component="div">
//           KEY CONTROLS
//         </Typography>
//         <Typography variant="body2" sx={{ mb: .5, scale:"95%" }} color="text.secondary" noWrap={false}>
//           Use arrow keys to navigate between pages in <strong>Classic Mode</strong> or panels in <strong>Cinema Mode</strong>.
//         </Typography>
//        <Icon><KeyboardIcon/></Icon>
      
//       </CardContent>
//     </Card>
// </Stack>
//     </Box>
//         </div>
//     )
//   }

//   const TipCard2=()=>{
//     return(
//         <div>
//        <Box 
//        sx={{
//         display:"block",
//         width:"inherit",
//         textAlign:"center",
//         alignContent:"center"
//         }}
//        >
//        <Stack alignItems="center">
//       <Card sx={{ 
//         minWidth: 100,
//         minHeight: 180,
//         maxHeight: 180,
//         backgroundColor: "rgba(0, 0, 0, .45)"
//         }}>
//       <CardContent>
//         <Typography variant="subtitle2" component="div">
//           DOUBLE-CLICK ZOOM
//         </Typography>
//         <Typography variant="body2" sx={{ mb: .5, scale:"95%" }} color="text.secondary" noWrap={false}>
//           In <strong>Classic Mode</strong>, you can double-click pages to zoom. You can also use the magnifying glass button in the menu.
//         </Typography>
//        <Icon><ZoomInIcon/></Icon>
      
//       </CardContent>
//     </Card>
// </Stack>
//     </Box>
//         </div>
//     )
//   }

  // const tipcards = [
  //   {div:<TipCard1 />},
  //   {div:<TipCard2 />}
  // ]
  // const maxSteps = tipcards.length

  const list = (anchor) => (
    <>
    

    <Box
               alignItems="center"
               spacing={0}
               sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
                role="presentation"
               >
              
          <Stack alignItems="left" m={0.3}>
                
          <Button variant="outlined" startIcon={<CloseIcon />}
          onClick={toggleDrawer(props.anchor, false)}
          >
            <Typography variant="h5" color={theme.palette.primary.main} sx={{textShadow: "1px 1px #00000050"}}><strong>SETTINGS</strong></Typography>
          </Button>
                </Stack>
                <Divider />
                
                <Divider />


             <Stack ml={.2}>  

               <Stack alignItems="left" m={.5}>
               <Stack container="true" direction="row" alignItems="center">
               <Icon className='excel_settings_icons'><ZoomInIcon /></Icon>
               <Typography variant="subtitle2" sx={{textShadow: "2px 2px #000000"}}> <strong>MAX ZOOM</strong></Typography>
              </Stack>
            
               <Typography variant="caption" sx={{opacity:.6}}>Adjust maximum value when magnifying comic pages in <strong>Classic Mode</strong>.</Typography>
               </Stack>
              <Toolbar>
              
              <Tooltip title="Set scale" arrow followCursor enterDelay={500} enterNextDelay={2200}>
                <CustSlider
                    onChange={handleZoomMaxSliderChange}
                    aria-label="Zoom max"
                    value={ZOOM_MAX}
                    marks
                    valueLabelDisplay="on"
                    disabled={working}
                    step={0.1}
                    min={1.5}
                    max={4}
                    
                    getAriaValueText={valueLabelFormat}
                    valueLabelFormat={valueLabelFormat}
                    aria-labelledby="non-linear-slider"
                    
                />
                </Tooltip>
                </Toolbar>
                

                <Divider />



                <Stack alignItems="left" m={.5}>
                <Stack container="true" direction="row" alignItems="center">
                <Icon className='excel_settings_icons'><SpeedIcon /></Icon> 
               <Typography variant="subtitle2" sx={{textShadow: "2px 2px #000000"}}><strong>TRANSITION SPEED</strong></Typography>
               </Stack>
               <Typography variant="caption" sx={{opacity:.6}}>Adjust transition speeds for panel-to-panel transitions. cross dissolves, etc.</Typography>
               </Stack>
              <Toolbar>
              
              <Tooltip title="Set speed" arrow followCursor enterDelay={500} enterNextDelay={2200}>
                <CustSlider
                    onChange={handleTransSpeedSliderChange}
                    aria-label="Transition speed"
                    value={TRANSITION_SPEED}
                    marks
                    valueLabelDisplay="on"
                    disabled={working}
                    step={0.1}
                    min={0}
                    max={1}
                    
                    getAriaValueText={valueLabelFormatSeconds}
                    valueLabelFormat={valueLabelFormatSeconds}
                    aria-labelledby="non-linear-slider"
                    
                />
                </Tooltip>
                </Toolbar>
                
                {!isMobile() &&
                <>
                <Divider />

                <Stack alignItems="left" m={.5}>
                <Stack container="true" direction="row" alignItems="center">
                <Icon className='excel_settings_icons'><MenuIcon /></Icon>
               <Typography variant="subtitle2" sx={{textShadow: "2px 2px #000000"}}> <strong>SMALL HAMBURGER</strong></Typography>
               </Stack>
               <Typography variant="caption" sx={{opacity:.6}}>Minimize the floating hamburger's visibility for cleaner reading experience.</Typography>
               <Stack alignItems="center">
              <FormGroup>
                <FormControlLabel control={<Switch 
                checked={MENU_SWITCH_VALUE}
                onChange={handleFabMenuSwitch}
                disabled={working}
                  />}  />
                </FormGroup>
                </Stack>
              </Stack>
              </>
                }

              <Divider />

            <Stack alignItems="left" m={.5}>
            <Stack container="true" direction="row" alignItems="center">
            <Icon className='excel_settings_icons'><AnimationIcon /></Icon>
            <Typography variant="subtitle2" sx={{textShadow: "2px 2px #000000"}}> <strong>ANIMATION CUES</strong></Typography>
            </Stack>
            <Typography variant="caption" sx={{opacity:.6}}>Enable cued animation enhancements in <strong>Cinema Mode</strong>. (Recommended)</Typography>
            <Stack alignItems="center">
            <FormGroup>
            <FormControlLabel control={<Switch 
            checked={FOCUS_ANIM_SWITCH_VALUE}
            onChange={handleFocusAnimSwitch}
            disabled={working}
              />}  />
            </FormGroup>
            </Stack>
            </Stack>
              

                {/* <Stack alignItems="left" m={.5}>
                <Stack container direction="row" alignItems="center">
                <Icon className='excel_settings_icons'><CompareArrowsIcon /></Icon>
               <Typography variant="subtitle2"> <strong>MANGA MODE</strong></Typography>
               </Stack>
               <Typography variant="caption" sx={{opacity:.6}}>When enabled, reading flow is swaped right-to-left in <strong>Focus Mode</strong>.</Typography>
              <Toolbar>
              
              <Tooltip title="Toggle direction" arrow followCursor enterDelay={500} enterNextDelay={2200}>
              <FormGroup>
                <FormControlLabel
                    control={<AmericanJapaneseSwitch 
                        checked={MANGA_SWITCH_VALUE}
                        onChange={handleMangaSwitch}
                        disabled={working}
                    sx={{ m: 1 }}  

                    />}
                    
                />
                </FormGroup>
                </Tooltip>
                </Toolbar>
                </Stack> */}

                

                <Divider />




                {/* <Stack alignItems="left" m={.5}>
                <Typography variant="subtitle1" component="span" mt={0} mb={.3} color={theme.palette.primary.main} sx={{textShadow: "1px 1px #000000"}}>
                  Did you know?
                </Typography>
           
              <Box>{tipcards[activeStep].div}</Box>
            
                
                <DotStepperBar />
                </Stack> */}
             
                </Stack>
                
            </Box>


            <Box 
             sx={{
                position: "absolute",
                bottom:0,
                width:"100%"
             }}
            >
            <Divider />
            <Stack alignItems="left" m={.5}>
                <Button variant="text" size="small" color="error"
                onClick={resetDefaultsHandler}
                disabled={working}
                sx={{textShadow: "1px 1px #00000050"}}
                >RESTORE DEFAULTS</Button>
                </Stack>
                <Divider />

               

                <Copyright className='excel_copyright'><MaskLogo className='excel_copyright_logo'/>{`${process.env.REACT_APP_NAME} v.${process.env.REACT_APP_VERSION} (Beta) © 2023`} </Copyright>
                </Box>

           
           
            </>
  )

return (
        <>
          <React.Fragment key={props.anchor}>
              <Drawer
                anchor={props.anchor}
                open={settingsMenuOpen}
                onClose={toggleDrawer(props.anchor, false)}
                transitionDuration={{enter: 0, exit: 0}}
                // PaperProps={{
                //   sx: { width: "20%" },
                // }}
                >
                <div styles={{overflow: "auto"}}>
                {list(props.anchor)}
                </div>
              </Drawer>
            </React.Fragment>
        </>
      )
}